// extracted by mini-css-extract-plugin
module.exports = {"badge_base":"Badge_badge_base__sTH8b","pod5_badge":"Badge_pod5_badge__ykVKR"};